export interface Difference {
    type: "CREATE" | "REMOVE" | "CHANGE";
    path: (string | number)[];
    value?: any;
    oldValue?: any;
}
